<div class="page-container">

  <div class="action-bar">
    <form [formGroup]="noMatchForm" id="search-by-policy-code">
      <div class="form-fields">
        <p-select
          class="form-field"
          [options]="countryCodes | orderBy: 'name' : 'asc'"
          optionLabel="name"
          optionValue="code"
          placeholder="Country Code"
          [(ngModel)]="countryCodesSelected"
          [ngModelOptions]="{ standalone: true }"
          appendTo="body"
        />
        <p-iconfield class="form-field" iconPosition="right">
          <input
            pInputText
            (blur)="searchByPhoneNumber()"
            placeholder="Search by phone e.g. 851234567"
            formControlName="phoneNumber"
          />
          <p-inputicon>
            <span class="material-icons">search</span>
          </p-inputicon>
        </p-iconfield>
      </div>
    </form>
  </div>

  <div>
    <p-table [value]="rows" sortMode="single">
      <ng-template pTemplate="header">
        <tr>
          <th>Phone Number</th>
          <th>Email</th>
          <th>DOB</th>
          <th pSortableColumn="timestamp">
            Date <p-sortIcon field="timestamp" />
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-element>
        <tr>
          <td>{{ element.phoneNumber }}</td>
          <td>{{ element.email }}</td>
          <td>{{ element.dob }}</td>
          <td>{{ element.timestamp | date: "dd/MM/yyyy H:mm aaa" }}</td>
        </tr>
      </ng-template>
    </p-table>
    @if (!isLoadingResults && rows.length == 0) {
      <div class="no-records-found-container">
        <span>No record found</span>
        <div>Please, Make sure the country is selected correctly.</div>
      </div>
    }
    @if (isLoadingResults) {
      <div class="table-spinner-container">
        <p-progressspinner ariaLabel="loading" />
      </div>
    }
  </div>
</div>
